/**
 * تذييل الموقع.
 *
 * وجوده ليس تزييناً: الصفحات النظامية لا قيمة لها إن لم يجدها أحد. والتذييل
 * هو المكان الذي يبحث فيه الناس عنها بحكم العادة — فلا يُخترع لها مكان جديد.
 *
 * وفيه سطر إخلاء المسؤولية مختصراً من مصدره الواحد: من يهبط على أي شاشة يقرأ
 * حدّ المنتج قبل أن يبني عليه رقماً.
 *
 * ورابط «كيف يعمل نطاق» أوّلها: الملاحة مجمّدة على خمسة عناصر، والتذييل هو
 * المكان الوحيد الظاهر في كل شاشة الذي يتسع لمدخل الشرح بلا كسر التجميد.
 */

import { Link } from 'react-router-dom';
import { color } from '@/design/tokens';

const LINKS: { to: string; label: string }[] = [
  { to: '/guide', label: 'كيف يعمل نطاق' },
  { to: '/terms', label: 'الشروط والأحكام' },
  { to: '/privacy', label: 'سياسة الخصوصية' },
  { to: '/disclaimer', label: 'إخلاء المسؤولية' },
];

export function Footer(): JSX.Element {
  return (
    <footer
      data-testid="site-footer"
      /* يمتدّ إلى حافّتي الشاشة كما الترويسة — الخطّ العلوي يفصل الصفحة لا صندوقاً. */
      className="nq-bleed"
      style={{
        marginTop: 40,
        borderTop: `1px solid ${color.hairlineSoft}`,
        background: color.ink900,
        paddingBlock: '18px 26px',
      }}
    >
      <nav
        aria-label="روابط التذييل"
        style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 4 }}
      >
        {LINKS.map((link) => (
          <Link
            key={link.to}
            to={link.to}
            /**
             * الحشوة الرأسية ليست تزييناً: بلا هذه المساحة يصير ارتفاع الرابط
             * ٢٠ بكسل — أصغر من أن يُصاب بإصبع على شاشة جوال.
             */
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              minHeight: 44,
              padding: '0 14px',
              fontSize: 13,
              color: color.textMuted,
              textDecoration: 'none',
            }}
          >
            {link.label}
          </Link>
        ))}
        <span style={{ flex: 1 }} />
        <span className="nq-micro" style={{ padding: '0 14px' }}>
          نطاق · قراءة أسعار السوق العقاري
        </span>
      </nav>

      <p
        style={{
          margin: '10px 14px 0',
          maxWidth: 760,
          fontSize: 11.5,
          lineHeight: 1.8,
          color: color.micro,
        }}
      >
        الأرقام المعروضة تقديرات آلية مبنية على صفقات مسجّلة رسمياً، وليست تقرير تقييم
        معتمد.
      </p>
    </footer>
  );
}
